import { Error } from "@mui/icons-material";
import { keyframes, styled } from "@mui/material";

const breatheKeyframes = keyframes`
  0% { opacity: 0.2; }
  50% { opacity: 1; }
  100% {opacity: 0.2; }
`;

const AnimatedErrorIcon = styled(Error)`
  animation: ${breatheKeyframes} 3s ease-in-out infinite;
`;

export { AnimatedErrorIcon };
